/**
 * Format raw ISBN string into standard ISBN format with dashes.
 * @param {string} isbnRaw - Raw ISBN input string
 * @returns {string} Formatted ISBN string (e.g. ISBN978-4-911-00001-9)
 */
export function formatIsbn (isbnRaw) {
  if (!isbnRaw || typeof isbnRaw !== 'string') {
    return ''
  }

  const str = isbnRaw.trim()
  if (!str) return ''

  const hasPrefix = str.toUpperCase().startsWith('ISBN')
  const digitsStr = str.replace(/^ISBN\s*/i, '')

  // If already contains dashes, return with ISBN prefix
  if (digitsStr.includes('-')) {
    return hasPrefix ? str : `ISBN${digitsStr}`
  }

  // Clean all non-digit characters to format raw digits
  const onlyDigits = digitsStr.replace(/\D/g, '')

  if (onlyDigits.length === 13 && onlyDigits.startsWith('9784')) {
    if (onlyDigits.startsWith('9784911')) {
      return `ISBN978-4-911-${onlyDigits.slice(7, 12)}-${onlyDigits.slice(12)}`
    }
    return `ISBN978-4-${onlyDigits.slice(4, 7)}-${onlyDigits.slice(7, 12)}-${onlyDigits.slice(12)}`
  }

  return hasPrefix ? str : `ISBN${digitsStr}`
}
